<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="editEventCondition">
<!-- <div class="modal-content editEventCondition"> -->
  <div style="background-color: #548235;  height: 7px;"></div>
  <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 40px; padding-top: 15px;  border-radius: 0px; text-align: center;">
    <h5 class="modal-title" style="color:black; text-transform: none;">Threshold</h5>
  </div>
  <div class="modal-body">
    <table style="border-collapse: collapse; border-spacing: 0;">
      <tr style="margin: 2px">
        <td style="vertical-align: middle; text-align: center; width: 42px;">
          <div style="font-size: 48px; cursor: pointer;" (click)="quickEditDecreaseThreshold()">&#9665;</div>
        </td>
        <td style="vertical-align: middle; text-align: center; width: 80px">
          <input [(ngModel)]="quickEditThreshold" class="form-control" style="font-size: 16px; text-align: center" id="threshold" name="threshold" required type="text">
        </td>
        <td style="vertical-align: middle; text-align: center; width: 42px;">
          <div style="font-size: 48px; cursor: pointer;" (click)="quickEditIncreaseThreshold()">&#9655;</div>
        </td>
      </tr>
      <tr>
        <td style="vertical-align: middle; text-align: center; width: 42px;">

        </td>
        <td style="vertical-align: middle; text-align: center; width: 80px;">
          <div style="color: green; font-size: 16px; padding-top: 10px; cursor: pointer;" data-dismiss="quickEditModal" (click)="updateEventCondition()">Save</div>
        </td>
        <td style="vertical-align: middle; text-align: center; width: 42px;">
          <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 10px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
        </td>
      </tr>
    </table>
  </div>
</div>

